import { Box } from '@wishket/design-system';
import { twJoin } from 'tailwind-merge';

import { Skeleton } from '@/shared/Components';

const MostHighlightedStatementSkeleton = () => {
  return (
    <Box
      className={twJoin(
        'flex gap-4 pr-5 tablet:gap-6 desktop:pr-9',
        'overflow-x-scroll scrollbar-hide',
        'pl-[max(calc((100dvw-1200px)/2+28.5px),20px)] desktop:pl-[max(calc((100dvw-1200px)/2+28.5px),36px)]' // GridLayout 만큼의 왼쪽 패딩
      )}
    >
      {Array.from({ length: 3 }).map((_, index) => (
        <Skeleton
          className="h-[230px] w-[210px] shrink-0 tablet:h-[238px] tablet:w-[360px]"
          key={index}
        />
      ))}
    </Box>
  );
};

export default MostHighlightedStatementSkeleton;
